"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoSection = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Text_1 = require("../../atoms/Text");
const Button_1 = require("../../atoms/Button");
function InfoSection({ testId, className, title, primaryAction, children, }) {
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('block', 'w-full', 'border', 'border-borderColor', 'rounded-default', 'mb-6', 'p-6', className), "data-testid": testId },
        react_1.default.createElement("div", { className: (0, classnames_1.default)('flex', 'justify-between', 'items-center', 'mb-8', 'cursor-default') },
            react_1.default.createElement(Text_1.Text, { type: Text_1.TextType.HEADING_L }, title),
            primaryAction ? (react_1.default.createElement(Button_1.Button, { type: primaryAction.type || Button_1.ButtonType.PRIMARY, testId: `${testId}:primary-action-button`, disabled: primaryAction.disabled, onClick: () => primaryAction.onClick() },
                primaryAction.icon,
                primaryAction.text)) : null),
        children));
}
exports.InfoSection = InfoSection;
//# sourceMappingURL=InfoSection.js.map